module.exports = __webpack_public_path__ + "img/sidenav-item-print.ae11fbd6.svg";